
import React from "react";
import Layout from "@/components/layout/Layout";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { AlertCircle } from "lucide-react";

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      navigate('/auth/login');
      return;
    }

    const { data: adminData } = await supabase
      .from('admin_users')
      .select('user_id')
      .eq('user_id', session.user.id)
      .single();

    console.log('Admin Check:', {
      userId: session.user.id,
      isAdmin: !!adminData,
      adminData
    });

    setIsAdmin(!!adminData);
    
    if (!adminData) {
      navigate('/');
    }
  };

  if (isAdmin === null) {
    return <Layout>
      <div className="container py-16">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
      </div>
    </Layout>;
  }

  if (isAdmin === false) {
    return <Layout>
      <div className="container py-16">
        <div className="flex items-center justify-center gap-2 text-red-600">
          <AlertCircle className="h-5 w-5" />
          <span>You don't have permission to access this page</span>
        </div>
      </div>
    </Layout>;
  }

  return <Layout hideFooter>{children}</Layout>;
}
